import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_CONSENT_ADD, MANAGE_CONSENT_List, MANAGE_CONSENT_REMOVE, MANAGE_CONSENT_UPDATE, MANAGE_CONSENT_VIEW } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const consentApi = createApi({
    reducerPath: 'consentApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/consent_forms",
    }),
    tagTypes: ["FormList", "FormDetails"],
    endpoints: (builder) => ({

        // List
        getConsentFormList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, consent_for = "", sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: MANAGE_CONSENT_List,
                data: { search, status, page, limit, sort, consent_for },
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["FormList"]
        }),

        // create consent form
        createConsentForm: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_CONSENT_ADD,
                data
            }),
            invalidatesTags: ["FormList"]
        }),

        // consent form details
        getConsentFormDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_CONSENT_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["FormDetails"]
        }),

        // update consent form
        updateConsentForm: builder.mutation({
            query: ({ id, data }) => ({
                method: "PUT",
                url: `${MANAGE_CONSENT_UPDATE}/${id}`,
                data
            }),
            invalidatesTags: ["FormList", "FormDetails"]
        }),

        // delete consent form
        deleteConsentForm: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_CONSENT_REMOVE}/${id}`
            }),
            invalidatesTags: ["FormList", "FormDetails"]
        }),
    }),
})

export const {
    useCreateConsentFormMutation,
    useGetConsentFormListQuery,
    useGetConsentFormDetailsQuery,
    useUpdateConsentFormMutation,
    useDeleteConsentFormMutation

} = consentApi;